import { render, staticRenderFns } from "./SecuritySensitiveVerifyHost.vue?vue&type=template&id=255bd142"
import script from "./SecuritySensitiveVerifyHost.vue?vue&type=script&lang=js"
export * from "./SecuritySensitiveVerifyHost.vue?vue&type=script&lang=js"
import style0 from "./SecuritySensitiveVerifyHost.vue?vue&type=style&index=0&id=255bd142&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports